<template>
  <div>
    
    <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />
    
    <UiNarrowContent>
  <div class="mt-8 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-32">
    <div 
      v-for="(item, index) in supportMenu.items" 
      :key="item.url" 
      
      :class="{
        'md:col-span-2': supportMenu.items.length % 2 !== 0 && index === supportMenu.items.length - 1
      }"
    >
      <NuxtLink
        class="btn flex place-content-center p-8 text-gravaadeepbrown bg-gravaawarmgray"
        :to="menuStore.stripDomain(item.url)"
      >
        <p class="large m-0">{{ item.title }}</p>
      </NuxtLink>
    </div>
  </div>
</UiNarrowContent>

    
    <UiHeroBottom v-if="bottomHeroArticle" :article="bottomHeroArticle" />
    
  </div>
</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
import { useMenuStore } from '@/stores/menuStore';
const blogStore = useBlogStore();
const menuStore = useMenuStore();



const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
  
});

const { data: supportMenu, error: menuError } = await useAsyncData('supportMenu', async () => {
  return await menuStore.fetchMenuByHandle('support-menu');
});

const bottomHeroArticle = computed(() => {
  try{
    return blogStore.filterArticlesByTag(props.blog, 'Herobottom')[0] || null;
  }
  catch (error) {
    console.error('Error fetching bottom hero article:', error);
    return null;
  }
});

</script>

<style scoped>
.btn {  
  transition: transform 0.3s ease-in-out;
}

.btn:hover {
  transform: scale(1.03);
  /* Slightly larger on hover */
}

/* Remove margins on extra small screens */
@media (max-width: 480px) { /* Extra small screens */
  .mb-32 {
    margin-bottom: 64px !important;
  }

}
</style>